import { createContext, Dispatch, SetStateAction } from "react";
import { CalendarDay, CalendarWeek } from "react-day-picker";

export const compareTwoDate = (date1: Date, date2: Date): boolean => {
	return (
		date1.getDate() === date2.getDate() &&
		date1.getMonth() === date2.getMonth() &&
		date1.getFullYear() === date2.getFullYear()
	);
};

// Configuración para animación de transiciones de los meses del Calendario.
export const variantsMonths = {
	initial: (direction: string) => ({
		x: direction === "right" ? "100%" : "-100%",
		opacity: 0,
	}),
	visible: {
		x: "0%",
		opacity: 1,
	},
	exit: (direction: string) => ({
		x: direction === "right" ? "-100%" : "100%",
		opacity: 0,
	}),
};

export const variantsSmallCalendar = {
	initial: {
		height: "20%",
		width: "100%",
		y: "-5rem",
	},
	visible: {
		height: "100%",
		width: "100%",
		y: "0",
	},
	exit: {
		height: "0%",
		y: "-5rem",
	},
};

export const variantsBigCalendar = {
	initial: {
		y: 500,
		width: "0%",
		opacity: 0,
		height: "0%",
	},
	visible: {
		y: 10,
		width: "100%",
		opacity: 1,
		height: "100%",
	},
	exit: {
		y: 500,
		width: "0%",
		opacity: 0,
		height: "0%",
	},
};

// Funciones para el calendario
export function isCurrentWeek(weekNumber: number): boolean {
	const today = new Date();
	const startOfYear = new Date(today.getFullYear(), 0, 1);
	const daysSinceStart = (today.getTime() - startOfYear.getTime()) / 86400000;
	const currentWeek = Math.ceil((daysSinceStart + 1) / 7);

	return weekNumber === currentWeek;
}

export function canDisplayWeek(week: CalendarWeek): boolean {
	return !week.days.every((day: CalendarDay) => day.outside);
}

/**
 * Obtiene el nombre del turno según sú número
 * @param shiftNumber Donde 0: matutino, 1: vespertino, 2: nocturno
 * @returns Nombre del turno
 */
export const getShiftNameByNumber = (shiftNumber: number): string => {
	switch (shiftNumber) {
		default:
			return "matutino";
		case 1:
			return "vespertino";
		case 2:
			return "nocturno";
	}
};

// Configuración para la creación del DayPickerContext
type DataType = Record<string, any[]>;

export const DayPickerContext = createContext<{
	selected?: Date;
	setSelected?: Dispatch<SetStateAction<Date>>;
	nurseCount?: DataType;
}>({});
